var _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 60,
    viewBox: "0 0 220 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_4709_138013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3145 18.2173C45.6743 18.2173 45.831 18.3856 45.7832 18.7212L44.5039 26.7974H45.3252L44.8838 29.5825H44.0625L43.5869 32.5815C43.323 34.0933 43.4667 35.2335 44.0186 36.0015C44.5945 36.7454 45.5667 37.1176 46.9346 37.1177C48.3746 37.1177 49.4427 36.7333 50.1387 35.9653C50.5866 35.4726 50.942 34.8455 51.2041 34.0835H52L52.415 31.7261H51.709L51.8115 31.0835H55.1328L55.2139 30.6548H51.8789L53.2402 22.0835H52.2148L52.3076 21.6548H54.3574L54.4639 21.0122H53.4102L53.7744 18.7212C53.8225 18.3855 53.9915 18.2173 54.2793 18.2173H59.0664C59.4262 18.2173 59.5829 18.3856 59.5352 18.7212L58.5518 24.8687H59.373L58.6191 29.5825H57.7979L57.2666 32.9058C57.2041 33.3121 57.1324 33.7044 57.0508 34.0825H57.8721C57.7582 34.6099 57.6256 35.1101 57.4746 35.5825H56.6523C56.3297 36.5916 55.9229 37.4756 55.4307 38.2339C54.9791 38.9488 54.4446 39.5643 53.8291 40.0825H54.6504C54.0885 40.5556 53.4592 40.9481 52.7607 41.2573C51.8548 41.6583 50.815 41.9345 49.6426 42.0874V41.9556C48.6936 42.1376 47.6473 42.23 46.5029 42.23C43.7292 42.23 41.5815 41.6556 40.0566 40.5122H45.3574L45.4639 39.8687H39.3203C38.142 38.6212 37.5929 36.8362 37.668 34.5122H39.3574L39.4639 33.8687H37.7031C37.737 33.4332 37.7888 32.9796 37.8633 32.5093L38.0527 31.2974H36.7861L36.8789 30.8687H38.1201L38.3213 29.5835H38.0713L38.1924 28.9409H38.9287L39.3438 26.5835H38.0713L38.1924 25.9409H38.8916L39.8652 19.7261H39.3574L39.5488 18.5835C39.5836 18.3772 39.7625 18.2261 39.9717 18.2261H40.4199C40.4534 18.2203 40.4888 18.2173 40.5264 18.2173H45.3145ZM75.751 17.7856C77.8387 17.7857 79.5424 18.0619 80.8623 18.6138C82.2063 19.1658 83.1429 19.982 83.6709 21.062C84.1494 21.9984 84.3112 23.1246 84.1582 24.4399H84.9805C84.9571 24.6411 84.9259 24.8471 84.8877 25.0571C84.8157 25.4171 84.6477 25.5971 84.3838 25.5972H78.8467C78.5108 25.5972 78.3672 25.4178 78.415 25.0581C78.4411 24.8364 78.4433 24.6307 78.4229 24.4409H77.5L77.5928 24.0122H81.9189L82 23.5835H78.1025C78.0099 23.4615 77.8977 23.3527 77.7666 23.2573C77.2627 22.8735 76.5067 22.6822 75.499 22.6821C74.635 22.6821 73.9624 22.85 73.4824 23.186C73.0026 23.498 72.7627 23.9301 72.7627 24.4819C72.7627 24.7698 72.8103 25.034 72.9062 25.2739C73.0262 25.4898 73.2186 25.7055 73.4824 25.9214C73.7704 26.1134 74.1548 26.342 74.6348 26.606L79.0264 28.8374C79.9623 29.3174 80.7189 29.8333 81.2949 30.3853C81.8949 30.9372 82.3268 31.5735 82.5908 32.2935C82.8788 33.0134 83.0225 33.854 83.0225 34.814C83.0224 35.3088 82.986 35.7793 82.918 36.2261H83.7402C83.4982 37.8155 82.8263 39.1006 81.7236 40.0825H80.9033L80.9023 40.0835H77.7959L77.7139 40.5122H80.3604C78.7353 41.656 76.4077 42.2299 73.375 42.23C71.239 42.23 69.4983 41.966 68.1543 41.438C67.2286 41.0508 66.4981 40.5273 65.9619 39.8687H68.7139L68.8213 39.2261H65.5254C65.4753 39.1371 65.4272 39.0465 65.3828 38.9536C65.2682 38.7025 65.1782 38.4358 65.1074 38.1548H64.4287L64.5215 37.7261H69.0615L69.1426 37.2974H63.7861L64.0371 35.7974H64.9756C65.009 35.4702 65.0604 35.1303 65.1309 34.7778C65.2029 34.4419 65.3829 34.2739 65.6709 34.2739H70.3145C70.6744 34.2739 70.8302 34.4419 70.7822 34.7778C70.7336 35.1672 70.753 35.5067 70.8359 35.7974H70.5098L70.4287 36.2261H71.8506C71.9563 36.3895 72.0892 36.5328 72.252 36.6548H71.4307C71.6028 36.7845 71.8065 36.8914 72.043 36.9741C72.5229 37.142 73.1352 37.2261 73.8789 37.2261C74.9827 37.226 75.7871 37.0693 76.291 36.7573C76.5343 36.6135 76.7206 36.4362 76.8516 36.2261H75.7861L75.8789 35.7974H78.2754L78.3574 35.3687H77.082C77.0821 35.3638 77.083 35.3589 77.083 35.354C77.083 35.0661 77.0102 34.802 76.8662 34.562C76.7462 34.298 76.5428 34.0573 76.2549 33.8413C75.9909 33.6013 75.6186 33.3737 75.1387 33.1577L71.0342 31.1421C70.0889 30.6694 69.307 30.1493 68.6875 29.5835H72.4902L72.5713 29.1548H67L67.1211 28.5122H67.7725C67.5797 28.2168 67.4181 27.906 67.291 27.5776C67.0031 26.8337 66.8584 25.9697 66.8584 24.9858C66.8584 24.7261 66.8704 24.4729 66.8916 24.2261H66.3574L66.4502 23.7974H69.7041L69.7861 23.3687H66.7861L67.0371 21.8687H66.3574L66.4502 21.4409H67.7295C68.1004 20.7976 68.589 20.2268 69.1982 19.73C70.7822 18.434 72.967 17.7857 75.751 17.7856ZM21.959 18.2173C25.0549 18.2173 27.2994 18.7696 28.6914 19.8735C29.5141 20.526 30.0913 21.3347 30.4277 22.2974H26.6074L26.5 22.9409H30.6113C30.7217 23.4314 30.7793 23.9572 30.7793 24.5181C30.7793 24.9348 30.758 25.3374 30.7168 25.7261H31.5381C31.3858 27.1726 30.951 28.4258 30.2324 29.4849C30.2097 29.5177 30.1853 29.5501 30.1621 29.5825H29.3408C28.4317 30.851 27.1361 31.7552 25.4512 32.2935V32.3657L26.917 35.5825H27.7383L28.8125 37.9399H27.9912L29.5186 41.2935C29.5665 41.3894 29.5553 41.4978 29.4834 41.6177C29.4354 41.7377 29.315 41.7974 29.123 41.7974H23.8311C23.5671 41.7973 23.3627 41.6416 23.2188 41.3296L23.0557 40.9409H22L21.6787 40.2974H23.6582L22.9082 38.7974H21.3896L21.0684 38.1548H21.8838L19.7988 33.1938H17.3154L17.0703 34.7261H15L14.9287 35.1548H17.5L17.249 36.6548H16.7607L16.2803 39.6548H17.2861L17.1924 40.0835H16.2119L16.0186 41.2935C15.9706 41.6295 15.8026 41.7974 15.5146 41.7974H10.0781C9.81318 41.7974 9.61156 41.5596 9.65527 41.2983L9.82324 40.2974H10.416L10.7207 38.3687H13.5713L13.6426 37.9409H9.14258L9.26367 37.2974H10.4648L10.6436 36.2261H8.92871L9.0498 35.5835H11.1602L11.9727 30.4409H9.78613L9.92578 29.7974H13.0137L13.4287 27.4409H12.4463L12.8184 25.0835H11.7139L11.9658 23.5835H13.0557L13.1572 22.9409H12.7861L12.9629 21.6548H13.3604L13.5293 20.5835H19.75L19.8574 19.9409H13L13.1396 19.2974H13.7324L13.8232 18.7212C13.8713 18.3856 14.0393 18.2173 14.3271 18.2173H21.959ZM100.096 18.2173C100.455 18.2174 100.611 18.3856 100.563 18.7212L100.438 19.5112H99.6172L99.1777 22.2974H100.857L100.764 22.7261H98.3672L98.2861 23.1548H99.043L98.374 27.3979H98.4092L97.9072 30.5474H98.7139L98.332 32.5835H97.5703L97.0908 35.5835H96.6533L96.5713 36.0112H97.8438L97.7402 36.6548H96.9189L96.4736 39.4409H95.3672L95.2861 39.8687H96.4053L96.1777 41.2935C96.1297 41.6295 95.9618 41.7974 95.6738 41.7974H90.8857C90.526 41.7973 90.37 41.6293 90.418 41.2935L90.7441 39.2261H90.1426L90.3945 37.7261H93.7041L93.7861 37.2974H90.5713L90.665 36.8687H91.1162L91.9629 31.5122H90.5713L90.665 31.0835H92.0303L92.1318 30.4409H91.4287L91.6611 29.3687H92.3018L92.4707 28.2974H94.9902L95.0713 27.8687H91.4287L91.5215 27.4409H92.6055L93.418 22.2974H91.6426L91.876 21.2261H93.5869L93.9824 18.7212C94.0305 18.3856 94.1985 18.2173 94.4863 18.2173H100.096ZM114.027 18.2173C114.387 18.2173 114.543 18.3855 114.495 18.7212L113.863 22.7261H113.042L112.805 24.2261H113.071L112.885 25.0835H112.669L111.925 29.7974H110.153L110.071 30.2261H112.679L111.664 36.6548H110.843L110.538 38.5835H108.867L108.786 39.0122H111.143L111.05 39.4409H110.403L110.11 41.2935C110.062 41.6294 109.882 41.7973 109.57 41.7974H104.818C104.458 41.7973 104.302 41.6294 104.35 41.2935L104.905 37.7261H104.071L104.165 37.2974H105.704L105.786 36.8687H105.039L105.718 32.5093H99.584L99.6465 32.1548H99.1426L99.2363 31.7261H99.7217L99.9863 30.2261H98.3867L98.8379 27.3979H106.546L106.843 25.5122H105.143L105.236 25.0835H106.911L106.979 24.6548H106L106.093 24.2261H110.847L110.929 23.7974H107.113L107.914 18.7212C107.962 18.3856 108.13 18.2173 108.418 18.2173H114.027ZM18.4434 25.9409H18.8975L18.5713 27.6548H18.1748L18.0352 28.5493H20.915C22.1445 28.5493 23.0929 28.3223 23.7607 27.8687H24.582C24.6181 27.8441 24.654 27.8193 24.6885 27.7935C24.8273 27.6893 24.9514 27.5717 25.0615 27.4409H23.7139L23.8076 27.0122H24.5244C24.7575 26.5645 24.875 26.0092 24.875 25.3452C24.8749 24.5776 24.6108 24.038 24.083 23.7261C23.579 23.4141 22.7627 23.2573 21.6348 23.2573H18.8633L18.4434 25.9409Z",
    fill: "#FFE03F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddd_4709_138013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.28 18.2178C145.136 18.2178 147.248 18.6618 148.616 19.5498C149.087 19.842 149.478 20.1865 149.789 20.583H150.424C150.935 21.2298 151.233 22.015 151.319 22.9404H147.203L147.143 23.3691H152.821L152.729 23.7979H150.698C150.648 25.1594 150.243 26.3117 149.48 27.2539C148.665 28.2617 147.536 28.9457 146.097 29.3057V29.4141C147.392 29.6781 148.365 30.2173 149.013 31.0332C149.141 31.1839 149.256 31.3435 149.359 31.5117H149.997C150.161 31.7756 150.293 32.0613 150.396 32.3682H149.757V32.3691H148.077L148.214 32.7979H149.878C149.973 33.2079 150.021 33.6521 150.021 34.1299C150.02 34.5608 149.996 34.9735 149.946 35.3682H150.59C150.439 36.5812 150.056 37.6237 149.439 38.4941C149.13 38.9224 148.76 39.3091 148.333 39.6543H147.679L147.678 39.6553H145.301L145.214 40.083H148.964L148.871 40.5117H146.321C145.95 40.6958 145.551 40.8614 145.124 41.0059C143.516 41.5337 141.5 41.7979 139.076 41.7979H131.049C130.737 41.7978 130.605 41.6296 130.652 41.2939L130.675 41.1543H128.071L128.165 40.7266H135.143L135.25 40.083H130.844L131.013 39.0117H130.429L130.644 37.7266H129.786L129.907 37.083H131.317L131.825 33.8691H132.923V33.8682H132.469L132.705 32.3691H132.062L132.569 29.1553H134.423L134.5 28.7266H132.143L132.236 28.2979H132.704L133.111 25.7266H129.357L129.45 25.2979H133.179L133.28 24.6553H131.071L131.276 23.583H138.143L138.25 22.9404H133.551L133.991 20.1553H132.786L132.879 19.7266H135.065L135.143 19.2979H134.126L134.217 18.7217C134.265 18.3859 134.456 18.2179 134.792 18.2178H142.28ZM137.831 32.3682H138.476L138.238 33.8682H137.594V33.8691H136.935L136.857 34.2979H137.526L137.097 37.0098H140.049C141.441 37.0097 142.473 36.7932 143.145 36.3613C143.513 36.1244 143.78 35.7936 143.946 35.3691H144.593V35.3682H144.923L145 34.9404H142.214L142.308 34.5117H144.136C144.146 34.3893 144.152 34.2621 144.152 34.1299C144.152 33.3859 143.888 32.8458 143.36 32.5098C142.832 32.1738 141.944 32.0059 140.696 32.0059H137.889L137.831 32.3682ZM138.572 27.7217H141.164C141.908 27.7217 142.544 27.6255 143.072 27.4336C143.6 27.2416 143.997 26.9411 144.261 26.5332C144.525 26.1253 144.656 25.6091 144.656 24.9854C144.656 24.2416 144.441 23.7255 144.009 23.4375C143.577 23.1495 142.82 23.0059 141.74 23.0059H139.328L138.572 27.7217Z",
    fill: "#FFE03F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dddd_4709_138013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.535 30.2139H125.257L124.857 32.5713H117.357L117.821 29.7861H118.672L119.071 27.4287H127L126.535 30.2139Z",
    fill: "#FFE03F"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dddd_4709_138013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.02 40.709C157.74 41.3502 157.102 41.7861 156.376 41.7861H155.103C154.425 41.7859 153.872 41.3195 153.713 40.709H158.02ZM158.379 40.708H155.502L155.562 40.5293H153.68C153.663 40.3949 153.663 40.2549 153.686 40.1133L153.827 39.2725H154.186L154.235 38.9766C154.379 38.111 155.129 37.4766 156.006 37.4766H157.278C158.165 37.4767 158.841 38.274 158.695 39.1494L158.585 39.8105H158.225L158.146 40.2861C158.132 40.3695 158.111 40.4506 158.086 40.5293H158.446C158.427 40.5904 158.405 40.6501 158.379 40.708Z",
    fill: "#FFE03F"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dddd_4709_138013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.04 18.2144C176.146 18.2144 177.882 18.5271 179.247 19.1519C180.635 19.7535 181.631 20.6327 182.232 21.7896C182.418 22.146 182.563 22.5256 182.667 22.9282H184.573L184.681 23.3569H183.401C183.509 23.9531 183.536 24.5958 183.479 25.2856H182.837C182.818 25.5155 182.79 25.7505 182.753 25.9907C182.73 26.3143 182.568 26.4759 182.268 26.4761L177.65 26.4419C177.304 26.4418 177.153 26.2794 177.199 25.9556C177.21 25.8735 177.217 25.793 177.221 25.7144H176.5L176.569 25.2856H177.209C177.143 24.7217 176.873 24.2623 176.4 23.9077C175.806 23.4409 174.958 23.1906 173.858 23.1519C172.722 23.2061 171.816 23.5385 171.142 24.1499C170.424 24.821 169.961 25.8865 169.753 27.3442L169.739 27.4282H170.714L170.645 27.8569H169.029L168.347 32.1694C168.205 33.0867 168.197 33.8634 168.321 34.4995H168.965V34.5005H170.071L170.002 34.9282H169.076C169.18 35.2436 169.325 35.5156 169.511 35.7446C170.085 36.4035 170.97 36.7582 172.169 36.812C173.269 36.7701 174.148 36.5093 174.804 36.0229C175.51 35.4763 175.968 34.6827 176.181 33.6431H177.786L177.893 33.0005H176.286L176.297 32.9331H172.616C172.27 32.9329 172.119 32.7712 172.165 32.4478L172.18 32.3569H172.605L172.964 30.2144H172.519L172.616 29.6011C172.686 29.2772 172.86 29.1149 173.138 29.1147H181.781C182.128 29.1148 182.279 29.2772 182.232 29.6011L182.133 30.2144H182.607L182.248 32.3569H181.787L181.44 34.4995H182.084L182.015 34.9282H178.75L178.643 35.5718H182.5L182.431 35.9995H181.207C181.066 36.9595 180.956 37.8238 180.879 38.5923C180.841 38.969 180.815 39.319 180.797 39.6421H181.439C181.413 40.1123 181.404 40.5258 181.418 40.8823C181.418 41.2062 181.255 41.3685 180.932 41.3687H176.574C176.251 41.3685 176.088 41.207 176.088 40.8833C176.088 40.6288 176.1 40.304 176.123 39.9106C176.169 39.5175 176.203 39.1472 176.227 38.8003H176.157C175.648 39.4943 175.082 40.0619 174.457 40.5015C173.856 40.941 173.184 41.2649 172.443 41.4731C171.703 41.6814 170.846 41.7856 169.874 41.7856C168.162 41.7856 166.715 41.3917 165.535 40.605C165.29 40.4416 165.062 40.2623 164.847 40.0718H163.214L163.284 39.6431H165.046C164.639 39.2026 164.3 38.7023 164.025 38.1431H163.383C163.253 37.8778 163.136 37.5991 163.035 37.3071C162.829 36.6988 162.693 36.0485 162.624 35.3569H164.821L164.929 34.7144H162.58C162.552 33.9587 162.599 33.1562 162.723 32.3081L162.988 30.6431H166.536L166.643 30.0005H160.857L160.964 29.3569H163.192L163.568 27.0005H162.786L162.855 26.5718H164.283C164.462 25.5469 164.718 24.6181 165.055 23.7856H164.412C164.992 22.3483 165.805 21.1961 166.854 20.3315C166.932 20.2667 167.014 20.2049 167.096 20.1431H170.338L170.446 19.7144H166.214L166.284 19.2856H168.518C170.014 18.5733 171.854 18.2144 174.04 18.2144Z",
    fill: "#1CFFFB"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dddd_4709_138013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.826 18.2144C202.932 18.2144 204.668 18.5271 206.033 19.1519C207.422 19.7535 208.417 20.6326 209.019 21.7896C209.204 22.146 209.348 22.5256 209.452 22.9282H211.358L211.466 23.3569H210.187C210.295 23.9532 210.322 24.5957 210.266 25.2856H209.623C209.604 25.5155 209.576 25.7505 209.539 25.9907C209.516 26.3144 209.353 26.4761 209.053 26.4761L204.437 26.4419C204.09 26.4418 203.938 26.2793 203.984 25.9556C203.995 25.8735 204.002 25.793 204.006 25.7144H203.286L203.355 25.2856H203.994C203.928 24.7216 203.659 24.2623 203.187 23.9077C202.592 23.4409 201.745 23.1906 200.645 23.1519C199.508 23.2061 198.603 23.5384 197.928 24.1499C197.21 24.821 196.747 25.8864 196.539 27.3442L196.525 27.4282H197.5L197.431 27.8569H195.815L195.133 32.1694C194.991 33.0867 194.983 33.8634 195.107 34.4995H195.75V34.5005H196.857L196.787 34.9282H195.862C195.966 35.2434 196.11 35.5157 196.296 35.7446C196.87 36.4036 197.756 36.7583 198.955 36.812C200.056 36.7701 200.934 36.5094 201.59 36.0229C202.296 35.4764 202.753 34.6826 202.966 33.6431H204.571L204.679 33.0005H203.071L203.082 32.9331H199.402C199.056 32.933 198.905 32.7713 198.951 32.4478L198.966 32.3569H199.391L199.75 30.2144H199.305L199.402 29.6011C199.472 29.2773 199.645 29.115 199.923 29.1147H208.567C208.914 29.1148 209.065 29.2772 209.019 29.6011L208.919 30.2144H209.393L209.034 32.3569H208.573L208.227 34.4995H208.869L208.8 34.9282H205.536L205.429 35.5718H209.286L209.216 35.9995H207.993C207.852 36.9594 207.741 37.8238 207.664 38.5923C207.626 38.969 207.6 39.319 207.582 39.6421H208.226C208.199 40.1123 208.189 40.5258 208.203 40.8823C208.203 41.2063 208.041 41.3687 207.717 41.3687H203.36C203.037 41.3685 202.874 41.207 202.874 40.8833C202.874 40.6288 202.885 40.304 202.908 39.9106C202.954 39.5174 202.99 39.1473 203.013 38.8003H202.943C202.434 39.4945 201.867 40.0618 201.242 40.5015C200.641 40.941 199.969 41.2649 199.229 41.4731C198.488 41.6813 197.632 41.7856 196.66 41.7856C194.948 41.7856 193.501 41.3918 192.32 40.605C192.075 40.4415 191.847 40.2623 191.632 40.0718H190L190.069 39.6431H191.833C191.427 39.2026 191.087 38.7023 190.812 38.1431H190.168C190.038 37.8778 189.922 37.5991 189.821 37.3071C189.615 36.6987 189.478 36.0486 189.409 35.3569H191.607L191.714 34.7144H189.365C189.337 33.9587 189.385 33.1562 189.509 32.3081L189.774 30.6431H193.321L193.429 30.0005H187.643L187.75 29.3569H189.979L190.354 27.0005H189.571L189.642 26.5718H191.069C191.248 25.5468 191.505 24.6182 191.842 23.7856H191.198C191.778 22.3483 192.591 21.1961 193.64 20.3315C193.718 20.2667 193.8 20.205 193.882 20.1431H197.123L197.232 19.7144H193L193.069 19.2856H195.302C196.799 18.573 198.64 18.2144 200.826 18.2144Z",
    fill: "#1CFFFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_4709_138013",
    x: 0.928711,
    y: 17.7856,
    width: 121.575,
    height: 24.4443,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4709_138013",
    result: "effect2_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.192157 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_4709_138013",
    result: "effect3_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.194017 0 0 0 0 0.247749 0 0 0 0.98 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_4709_138013",
    result: "effect4_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_4709_138013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddd_4709_138013",
    x: 120.071,
    y: 18.2178,
    width: 40.75,
    height: 23.5801,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4709_138013",
    result: "effect2_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.192157 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_4709_138013",
    result: "effect3_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.194017 0 0 0 0 0.247749 0 0 0 0.98 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_4709_138013",
    result: "effect4_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_4709_138013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dddd_4709_138013",
    x: 109.357,
    y: 27.4287,
    width: 25.6426,
    height: 5.14258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4709_138013",
    result: "effect2_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.192157 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_4709_138013",
    result: "effect3_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.194017 0 0 0 0 0.247749 0 0 0 0.98 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_4709_138013",
    result: "effect4_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_4709_138013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dddd_4709_138013",
    x: 152.232,
    y: 37.4766,
    width: 7.91962,
    height: 4.30957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.43637
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.718185
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4709_138013",
    result: "effect2_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.43637
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.192157 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_4709_138013",
    result: "effect3_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.718185
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.194017 0 0 0 0 0.247749 0 0 0 0.98 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_4709_138013",
    result: "effect4_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_4709_138013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dddd_4709_138013",
    x: 152.857,
    y: 18.2144,
    width: 39.8232,
    height: 23.5713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.878431 0 0 0 0 0.247059 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.878431 0 0 0 0 0.247059 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4709_138013",
    result: "effect2_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.192157 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_4709_138013",
    result: "effect3_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.192157 0 0 0 0 0.243137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_4709_138013",
    result: "effect4_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_4709_138013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dddd_4709_138013",
    x: 179.643,
    y: 18.2144,
    width: 39.8232,
    height: 23.5713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.878431 0 0 0 0 0.247059 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.878431 0 0 0 0 0.247059 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4709_138013",
    result: "effect2_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.192157 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_4709_138013",
    result: "effect3_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.192157 0 0 0 0 0.243137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_4709_138013",
    result: "effect4_dropShadow_4709_138013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_4709_138013",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/LOGO.09a1f1926d5ec77e95a9f9bf9ff2f204.svg";
export { ForwardRef as ReactComponent };